import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Evisio.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import "../../UI/Edit/Edit";

class Evisio extends compose(_WidgetBaseSP) {
    templateString: any = template;

    evisioLogoLight: HTMLImageElement;
    evisioLogoDark: HTMLImageElement;
    evisioCloseIcon: HTMLElement;
    evisioButton: HTMLElement;

    private container: HTMLElement;

    private _init(): void {
        this.container = document.getElementById("evisioContainer");
        if (!this.hasFeature("Evisio/Button")) {
            if (this.container) this.hideNode(this.container);
            this.destroy();
            return;
        }

        // Defer placement until the Evisio2_GeneralAccess role check resolves.
        // _WidgetBaseSP queues callbacks per-instance and flushes them when SessionInfo
        // publishes /Session/CheckForExistingSession, so this is safe even though Evisio
        // boots before SessionInfo in GlobalWidgetsLoader.init().
        this.hasUserRoleAsync("Evisio2_GeneralAccess").then((hasRole: boolean) => {
            if ((this as any)._destroyed) return; // destroyed mid-check — bail
            if (!hasRole) {
                if (this.container) this.hideNode(this.container);
                this.destroy();
                return;
            }
            // nicht drauf verlassen, dass im Layout wirklich so ein Container vorhanden ist!
            if (this.container) {
                this.UiModder.domConstruct.place(this.domNode, this.container);
            }
        });
    }

    private _onClickEvisioButton(e: MouseEvent): void {
        let appRoot: string = (window as any).appRoot || "/";
        if ((window as any).inEvisio2) {
            // Inside the evisio2 inner iframe: break out of the shell.
            // Top-window navigates to the iframe's current URL minus the inEvisio2 query param.
            try {
                let url = new URL(window.location.href);
                url.searchParams.delete("inEvisio2");
                let target = url.pathname + (url.search || "") + (url.hash || "");
                window.top.location.href = target;
            } catch (err) {
                window.top.location.href = appRoot;
            }
        } else {
            // Regular page: enter the evisio2 shell at the catch-all route for the current path.
            let currentPath = window.location.pathname.replace(/^\/+/, "");
            let appRootPathOnly = appRoot.replace(/^\/+/, "").replace(/\/+$/, "");
            if (appRootPathOnly && currentPath.indexOf(appRootPathOnly + "/") === 0) {
                currentPath = currentPath.substring(appRootPathOnly.length + 1);
            } else if (appRootPathOnly && currentPath === appRootPathOnly) {
                currentPath = "";
            }
            let currentSearch = window.location.search || "";
            let target = appRoot + "Evisio/" + currentPath + currentSearch;
            window.location.href = target;
        }
        e.stopPropagation();
    }

    private _onThemeChange(theme) {
        switch (theme) {
            case "dark":
                this.hideNode(this.evisioLogoLight, false);
                this.hideNode(this.evisioLogoDark, true);
                break;
            case "light":
                this.hideNode(this.evisioLogoLight, true);
                this.hideNode(this.evisioLogoDark, false);
                break;
        }
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if ((window as any).inEvisio2) {
            // Close-icon variant inside the evisio2 inner iframe.
            // Logos remain w3-hide; no Theme/Change subscription needed.
            this.evisioCloseIcon.classList.remove("w3-hide");
            this.evisioButton.title = this.translate("Evisio2_CloseSidebar");
        } else {
            this.addSubscription("Theme/Change", lang.hitch(this, this._onThemeChange));
            this.evisioButton.title = this.translate("Evisio2_OpenSidebar");
            let currentTheme = window.themeToggler.getTheme(true);
            this._onThemeChange(currentTheme);
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this._init();
    }
}

export default mdsWidget(Evisio);
